import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import * as CoinsLaunchedTime from '../model/coins-launched-time'

import type * as CoinsType from '../model/coins-type'
import type { DelugeId } from '@root/entities/user-short'

const toDto = (time: CoinsLaunchedTime.CoinsLaunchedTime) =>
  pipe(
    time,
    CoinsLaunchedTime.match({
      CoinsLaunchedHours: ({ hours }) => `${hours}H` as const,
      CoinsLaunchedDays: ({ days }) => `${days}D` as const,
      CoinsLaunchedAll: () => 'ALL' as const,
    }),
  )

export interface FetchMyCoinsArgs {
  coinsType: CoinsType.CoinsType
  launchedTime: CoinsLaunchedTime.CoinsLaunchedTime
  selectedNetwork: Network.Network
  delugeId: DelugeId
}

export const fetchMyCoinsRequestAction = action(
  async (ctx, filterState: FetchMyCoinsArgs) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userProfileDeployedTokensList, [
        {
          network: Network.toDto(filterState.selectedNetwork),
          period: toDto(filterState.launchedTime),
          delugeId: filterState.delugeId,
        },
      ]),
    )

    return result.pipe(Result.mapError(ApiError.fallbackToUnknown))
  },
  'fetchMyCoinsRequestAction',
)
